<!-- 议付 -->
<template>
  <div class="goodsTable">
    <vxe-toolbar v-if="$route.query.isEdit == 'Y'">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('acceptanceDetail.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('acceptanceDetail.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="goodsData"
      :columns="columnList"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableEditRules"
      auto-resize
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <collectionInfo ref="collectionInfo" :detail="detail"> </collectionInfo>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import collectionInfo from './collectionInfo';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  // import MASTER_API from '@/api/masterData/company.js';
  // import API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  // import { resolve, reject } from 'q';

  export default {
    name: 'delayLockExchangeRateTable',
    components: {
      collectionInfo,
      // SearchTable,
      // InputNumber,
    },
    props: ['type', 'baseData'],
    data() {
      return {
        returnStatus: '',
        delayInfo: {},
        goodsData: [],
        editConfig: { trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod },
        ladingNoLoading: false,
        ladingNoOptions: [], //提货仓库下拉数据
        delNegotiationList: [],
        detail: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('financeSalesInvoiceDetail.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          {
            title: '议付金额',
            field: 'negotiationAmount',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.negotiationAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['negotiationAmount']}
                    placeholder={this.$t('议付金额')}
                    clearable={true}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'negotiationAmount')}
                  ></input-number>,
                ];
              },
            },
          }, //议付金额
          {
            title: '议付汇率',
            field: 'negotiationRate',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.negotiationRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['negotiationRate']}
                    placeholder={this.$t('议付汇率')}
                    clearable={true}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'negotiationRate')}
                  ></input-number>,
                ];
              },
            },
          }, //议付汇率
          {
            title: '议付日期',
            field: 'negotiationDate',
            width: 200,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'date',
                format: 'yyyy/MM/dd',
                valueFormat: 'yyyy-MM-dd',
              },
            },
          }, //锁汇到期日
          {
            title: '议付银行',
            field: 'negotiationBank',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.negotiationBank}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bankAccount"
                    isMultiple={true}
                    currentValue={row['negotiationBank']}
                    checkRowKeys={[row['negotiationBank']]}
                    extraData={{ companyCode: this.baseData.businessCompanyCode }}
                    onInput={(val) => this.updateCol(row, val, 'negotiationBank')}
                  ></search-table>,
                ];
              },
            },
          }, //锁汇银行账户名
          {
            title: '议付银行账号',
            field: 'negotiationBankNumber',
            width: 200,
          }, //锁汇银行账户号码
          {
            title: '部门',
            field: 'departmentName',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.departmentName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="companyDept"
                    isMultiple={true}
                    currentValue={row['departmentName']}
                    checkRowKeys={[row['departmentCode']]}
                    extraData={{ belongCompanyCode: this.baseData.businessCompanyCode }}
                    onInput={(val) => this.updateCol(row, val, 'departmentName')}
                  ></search-table>,
                ];
              },
            },
          }, //部门
          {
            title: '备注',
            field: 'remark',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
          }, //备注
          {
            title: '议付状态',
            field: 'negotiationStatus',
            width: 200,
          }, //状态
        ];
      },
      goodsTableEditRules() {
        return {
          negotiationAmount: [
            {
              required: true,
              message: '请输入议付金额',
            },
          ],
          negotiationRate: [
            {
              required: true,
              message: '请输入议付汇率',
            },
          ],
          negotiationDate: [
            {
              required: true,
              message: '请选择议付日期',
            },
          ],
          negotiationBank: [
            {
              required: true,
              message: '请选择议付银行',
            },
          ],
          negotiationBankNumber: [
            {
              required: true,
              message: '请选择议付银行',
            },
          ],
          departmentName: [
            {
              required: true,
              message: '请选择部门',
            },
          ],
        };
      },
    },
    mounted() {
      console.log('delayLockExchangeRateTable');
    },
    methods: {
      //JSX更新字段
      updateCol(row, val, type) {
        row[type] = val;
        console.log('选择的银行', val);
        if (type == 'negotiationBank') {
          row.negotiationBankNumber = val[0].bankAccountNum;
          row.negotiationBank = val[0].bankName;
          row.branchCode = val[0].branchCode;
          row.branchName = val[0].branchName;
        } else if (type == 'lockAmount') {
          this.$refs.goodsTable.updateFooter();
        } else if (type == 'departmentName') {
          console.log('部门信息', val[0]);
          row.departmentName = val[0].createDepartmentName;
          row.departmentCode = val[0].createDepartmentCode;
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['lockAmount'].includes(column.property)) {
              return data
                .map((i) => i['lockAmount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
            }
            return null;
          }),
        ];
      },
      getDetail(allDetail) {
        if (allDetail != null && allDetail.length > 0) {
          this.goodsData = allDetail;
        }
      },
      // 载具表格新增一行
      insertEvent() {
        this.$refs.goodsTable.validate().then(() => {
          const record = {
            // tempDelayPaymentId: this.delayInfo.tempId,
            // acceptanceId: this.delayInfo.acceptanceId,
            // delayPaymentId: this.delayInfo.id,
            negotiationAmount: 0,
            negotiationRate: 0,
            negotiationDate: null,
            negotiationBank: null,
            negotiationBankNumber: null,
            departmentName: null,
            remark: null,
            negotiationStatus: null,
          };
          this.goodsData.push(record);
          this.$refs.goodsTable
            .insert(record, -1)
            .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('acceptanceDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) this.delNegotiationList.push(item.id);
            });
            this.$refs[goodsTable].removeSelecteds();
            this.goodsData = this.$refs[goodsTable].getTableData().fullData;
            this.$refs[goodsTable].updateFooter();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      // 返回数据
      exportChildData() {
        return new Promise((resolve, reject) => {
          const tableForm = {};
          let creditLetterNegotiationList = [];
          if (this.$refs.goodsTable.getTableData().fullData.length) {
            this.$refs.goodsTable.getTableData().fullData.map((item) => {
              console.log(item);
              creditLetterNegotiationList.push({
                tenantCode: this.userInfo.tenantCode,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                clCode: this.baseData.clCode,
                ...item,
              });
            });
          }
          tableForm.creditLetterNegotiationList = creditLetterNegotiationList;
          tableForm.delNegotiationList = this.delNegotiationList;
          // 点击提交，走校验
          // if (tableForm.creditLetterNegotiationList.length == 0) {
          //   this.$message({
          //     showClose: true,
          //     message: this.$t('acceptanceDetail.msg.delylockGoodsMsg'),
          //     type: 'error',
          //   });
          //   return false;
          // } else {
          this.$refs['goodsTable']
            .validate()
            .then((valid) => {
              console.log(valid);
              resolve(tableForm);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: this.$t('acceptanceDetail.msg.delylockGoodsMsg'),
                type: 'error',
              });
              reject();
            });
          // }
        });
      },

      activeRowMethod() {
        //禁用编辑
        return true;
      },
    },
  };
</script>
<style scoped>
  .acceptBaseInfo {
    float: right;
  }
  .acceptBaseInfoItem {
    margin-right: 20px;
  }
</style>
